import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/companies',
        name: 'companies',
        component: () => import('./pages/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/companies/:id',
        name: 'companies.show',
        component: () => import('./pages/Show.vue'),
        meta: {
            layout: 'app',
        },
    },
] satisfies RouteRecordRaw[];
